module.exports = __webpack_public_path__ + "img/1522105311.5ed9ee22.jpg";